<script setup lang="ts">
import AdministrationChrome from '@voix/voix-layer/components/administration/AdministrationChrome.vue'
import AdminButton from '@voix/voix-layer/components/administration/AdministrationButton.vue'
import DropdownSelect from '@voix/components/chrome/controls/DropdownSelect.vue'
import FormSection from '@voix/voix-layer/components/administration/AdministrationFormSection.vue'
import FormField from '@voix/voix-layer/components/administration/AdministrationFormField.vue'
import SubmissionGroup from '@voix/voix-layer/components/administration/AdministrationSubmissionGroup.vue'
import GlobalField from '@voix/components/chrome/fields/GlobalField.vue'

import { computed, ref } from 'vue'
import { usePageStore } from '@voix/store/pageStore'
import type { PropType, Ref } from 'vue'
import type { FieldInterface } from '@voix/types'
import { useNuxtApp } from '#imports'

const props = defineProps({
  pageField: {
    type: Object as PropType<FieldInterface>,
    required: true,
  },
})

const emit = defineEmits(['back'])
const { $voix } = useNuxtApp()

const pageStore = usePageStore()
const originalValue = props.pageField

const field: Ref<string> = ref(props.pageField.name)

const theField = computed(() => {
  return pageStore.currentPage.fields.find((f: FieldInterface) => f.id === props.pageField.id)
})

const fieldConfig = computed(() => {
  const config = $voix.options.pageFields[theField.value.name]
  config.name = field.value
  return config
})

function requestSave() {
  emit('back')
}

function requestCancel() {
  pageStore.updatePageField(
    originalValue.id,
    originalValue.name,
    originalValue,
  )
  emit('back')
}
</script>

<template>
  <AdministrationChrome
    title="Edit Page Field"
    :links="[
      {
        label: 'Back to All Page Fields',
        emit: 'back',
      },
    ]"
    @back="requestCancel"
  >
    <FormSection
      title="Page Field Settings"
    >
      <FormField label="Page Field">
        <span class="font-mono bg-gray-200 px-2 py-1 rounded-sm text-gray-800">{{ theField.name }}</span>
      </FormField>

      <FormField label="Value">
        <GlobalField
          v-if="theField"
          :field-data="theField"
          :field-configuration="fieldConfig"
          :is-page-field="true"
        />
      </FormField>
    </FormSection>

    <SubmissionGroup>
      <AdminButton type="primary" @click="requestSave">
        Done
      </AdminButton>
      <AdminButton type="secondary" @click="requestCancel">
        Cancel
      </AdminButton>
    </SubmissionGroup>
  </AdministrationChrome>
</template>
